"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShieldCross = void 0;
var _SVG = require("../SVG");
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const ShieldCross = _ref => {
  let {
    color = "#13126C",
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_SVG.SVG, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 43 50"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M2.322 10.533c-.337 18.066-.541 28.963 18.823 37.128 19.34-8.127 19.169-18.963 18.884-36.883l-.038-2.526C26.746.28 15.544.28 2.363 8.252l-.04 2.28ZM41.71 6.672c.329.199.527.527.527.923.012.975.026 1.932.04 2.869.29 19.442.457 30.699-20.667 39.437-.328.132-.592.132-.856 0h-.002C-.46 41.126-.262 29.81.081 10.22l.044-2.627c0-.395.199-.723.527-.922 14.367-8.896 26.69-8.896 41.057 0ZM22.697 30h-3.402a1.619 1.619 0 0 1-1.62-1.619v-3.06H14.62A1.619 1.619 0 0 1 13 23.703V20.3c0-.893.725-1.618 1.619-1.618h3.065v-3.065c0-.893.725-1.618 1.619-1.618h3.402c.891.005 1.611.728 1.611 1.618v3.065h3.065c.894 0 1.619.724 1.619 1.618v3.402c0 .894-.725 1.618-1.619 1.618h-3.065v3.065A1.619 1.619 0 0 1 22.697 30Zm-3.25-2h3.106v-3.646c0-.443.358-.801.8-.801H27v-3.106h-3.646a.801.801 0 0 1-.801-.8V16h-3.106v3.646a.801.801 0 0 1-.8.801H15v3.106h3.646c.443 0 .801.358.801.8V28Z",
    clipRule: "evenodd"
  }));
};
exports.ShieldCross = ShieldCross;
ShieldCross.displayName = "ShieldCross";